































































































import { Component } from 'vue-property-decorator';
import { Base } from '@/components/common/base';
import { WeOwe, WeOweNote } from '@/models/filebunker/weowe';
import { PaginationModel, VAction, VHeaders } from '@/models/pagedlistmodel';
import { CustomerContactInfo } from '@/models/filebunker/deal';
import { VoiceCallModel } from '@/models/fixedops/repairorder';
import { MetadataType, MetadataKeyIdentifier } from '@/enums/enums';
import { IDialogOption } from '@/models/dialog';
import { FileHelper } from '@/helper/file.helper';
import { Richtext } from 'dhx-richtext';
import 'dhx-richtext/codebase/richtext.css';
import * as marked from 'marked';
import * as dhx from 'dhx-richtext';
import {weOweService,customerService} from '@/shared';
import { Utils } from '@/helper/utils';


@Component({
  props: ['methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
  components: {
    Grid: () => import('@/components/common/app.grid.vue'),
    AppDialog: () => import('@/components/common/app.dialog.vue'),
    CallCustomer: () => import('@/components/common/call.customer.vue'),
    SnackBarLoader: () => import('@/components/common/loader.vue'),
    Richtext,
  },
})
export default class WeOweListPage extends Base {
  public actions: VAction[] = [];
  public pagination = new PaginationModel('weOweNumber');
  public loading: boolean = false;
  public weOwes: WeOwe[] = [];
  public selectedWeOweNumber: string = '';
  public statusModel: string = '';
  public weOweDownloadLoader: boolean = false;
  public notePagination = new PaginationModel('note', false, 5);
  public noteLoading: boolean = false;
  public noteActions: VAction[] = [];
  public notes: WeOweNote[] = [];
  public noteText: string = '';
  public noteDialog: IDialogOption = {
    title: this.$parent.$t('weOweList.noteDialog.title') as string,
    width: 1000,
    model: false,
    loading: false,
    action: {
      color: 'success',
      icon: 'fas fa-check',
      text: this.$parent.$t('weOweList.noteDialog.lblSave') as string,
    },
    onAction: () => {
      this.addNote();
    },
  };
  public deleteNoteDialog: IDialogOption = {
    width: 400,
    title: this.$parent.$t('weOweList.deleteNoteDialog.title') as string,
    model: false,
    loading: false,
    action: {
      color: 'success',
      icon: 'fas fa-check',
      text: this.$parent.$t('weOweList.deleteNoteDialog.lblAgree') as string,
    },
    onAction: (): void => {
      this.deleteNote();
    },
  };
  public selectedNoteId: string = '';
  public isTextEditorRender: boolean = false;
  public customerLoading: boolean = false;
  public richtext: any;
  public markdown: string = '';
  public dataType: { type: string; default: 'markdown' };

  public customer: CustomerContactInfo = {};
  public voiceCallDialog: boolean = false;
  public voiceCallModel: VoiceCallModel = {
    customerKey: '',
    customerName: '',
    recordIdentifier: MetadataType[MetadataType.Deal],
    recordKey: '',
    recordKeyIdentifier:
      MetadataKeyIdentifier[MetadataKeyIdentifier.WeOweNumber],
    vin: '',
    toNumber: '',
    callType: '',
  };
  public statuses: any[] = [
    {
      value: '',
      text: this.$parent.$t('weOweList.lblStatusAll') as string,
    },
    {
      value: 'Pending',
      text: this.$parent.$t('weOweList.lblStatusPending') as string,
    },
    {
      value: 'Finish',
      text: this.$parent.$t('weOweList.lblStatusFinish') as string,
    },
  ];

  public headers: VHeaders[] = [
    {
      text: this.$parent.$t('weOweList.weOweGrid.weOweNumber') as string,
      align: 'left',
      sortable: true,
      value: 'weOweNumber',
    },
    {
      align: 'left',
      sortable: true,
      text: this.$parent.$t('weOweList.weOweGrid.customerName') as string,
      value: 'customerName',
    },
    {
      align: 'left',
      sortable: true,
      text: this.$parent.$t('weOweList.weOweGrid.stock') as string,
      value: 'stockNumber',
    },
    {
      align: 'left',
      sortable: true,
      text: this.$parent.$t('weOweList.weOweGrid.year') as string,
      value: 'modelYear',
    },
    {
      align: 'left',
      sortable: true,
      text: this.$parent.$t('weOweList.weOweGrid.make') as string,
      value: 'make',
    },
    {
      align: 'left',
      sortable: true,
      text: this.$parent.$t('weOweList.weOweGrid.model') as string,
      value: 'model',
    },
    {
      align: 'center',
      sortable: false,
      text: this.$parent.$t('weOweList.weOweGrid.noOfWeOwe') as string,
      value: 'numberOfWeOweItems',
    },
    {
      align: 'center',
      sortable: false,
      text: this.$parent.$t('weOweList.weOweGrid.daysInWeOwe') as string,
      value: 'daysInWeOwe',
    },
    {
      align: 'left',
      sortable: false,
      text: this.$parent.$t('weOweList.weOweGrid.status') as string,
      value: 'currentStatus',
    },
    {
      align: 'center',
      sortable: false,
      isNotDataProp: true,
      text: 'Action'
    },
  ];

  public noteHeaders: VHeaders[] = [
    {
      align: 'left',
      sortable: true,
      text: this.$parent.$t('weOweList.weOweNoteGrid.note') as string,
      value: 'noteText',
      fieldType: 'html',
      class: 'w-100 text-truncate',
      filters: [
        (item) => {
          const htmlData = marked(item);
          return htmlData.length > 100
            ? htmlData.substring(0, 100) + '..'
            : htmlData;
        },
      ],
    },
    {
      align: 'left',
      sortable: true,
      text: this.$parent.$t('weOweList.weOweNoteGrid.creationTime') as string,
      value: 'createdAt',
      fieldType: 'date',
    },
    {
      align: 'left',
      sortable: false,
      text: this.$parent.$t('weOweList.weOweNoteGrid.createdBy') as string,
      value: 'createdByEmail',
    },
    {
      align: 'center',
      sortable: false,
      isNotDataProp: true,
      text: this.$parent.$t('weOweList.weOweNoteGrid.actions') as string,
      value: '',
    },
  ];

  public beforeDestroy() {
    const buttons = [];
    this.$emit('updateToolBar', buttons);
  }

  public callMethod(methodName): void {
    if (methodName === 'searchWeOwe') {
      this.searchWeOwe();
    }
    if (methodName === 'addWeOwe') {
      this.addWeOwe();
    }
    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
  }
  public updateToolBar(): void {
    const buttons: any = [];
    buttons.push({
      id: '1',
      type: 'button',
      title: this.$t('weOweList.btnAddWeOwe'),
      disabled: false,
      visible: true,
      class: 'btn',
      label: this.$t('weOweList.btnAddWeOwe'),
      click: 'addWeOwe',
      icon: 'fas fa-plus-circle',
      requestProgress: true,
    });
    this.$emit('updateToolBar', buttons);
  }
  public created() {
    dhx.i18n.setLocale('richtext', this.$t('richText'));
  }

  public mounted(): void {
    // activating tab
    this.$root.$emit('sidebar.layout.vue', 'weowe');

    this.updateToolBar();
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });
    this.setActions();
    if(this.$route.query.status){
      this.statusModel = this.$route.query.status.toString();
    }
    const pagination = Utils.getPaginationFromRouteQuery(this.$route.query);
    if (pagination) {
      this.pagination = pagination;
    }
    this.getWeOwes();
  }

  public addWeOwe() {
    this.$router.push({ name: 'app.weowe.add' });
  }
  public setActions(): void {
    this.actions = [
      {
        type: 'link',
        icon: 'fas fa-eye',
        title: this.$t('weOweList.weOweGrid.gridAction.detail') as string,
        visible: true,
        action: (model: WeOwe) => {
          return {
            name: 'app.weowe.detail',
            params: {
              weOweNumber: model.weOweNumber,
            },
          };
        },
      },
      {
        type: 'button',
        icon: 'fas fa-phone',
        title: this.$t('weOweList.weOweGrid.gridAction.call') as string,
        visible: true,
        disable: (model: WeOwe) => {
          if (model.customerNumber) {
            return false;
          }
          return true;
        },
        loading: false,
        action: (model: WeOwe) => {
          this.getCustomerInfo(model);
        },
      },
      {
        type: 'button',
        icon: 'fas fa-download',
        title: this.$t('weOweList.weOweGrid.gridAction.download') as string,
        visible: true,
        disable: (model: WeOwe) => {
          if (model.customerNumber && model.vin) {
            return false;
          }
          return true;
        },
        loading: false,
        action: (model: WeOwe, action: VAction) => {
          this.downloadWeOwe(model.weOweNumber, action);
        },
      },
      {
        type: 'link',
        icon: 'fas fa-comment',
        title: this.$t('weOweList.weOweGrid.gridAction.sendMessage') as string,
        visible: (model: any) => {
          return this.isFeatureToAccess('MESSAGING');
        },
        disable: (model: WeOwe) => {
          if (model.customerNumber) {
            return false;
          }
          return true;
        },
        action: (model: WeOwe) => {
          return {
            name: 'common.conversation.add',
            params: {
              type: MetadataType[MetadataType.WeOwe],
            },
            query: {
              customerKey: model.customerNumber,
              recordKey: model.weOweNumber,
              vin: model.vin,
              tab:'weowe'
            },
          };
        },
      },
      {
        type: 'link',
        icon: 'fas fa-paperclip',
        title: this.$t('weOweList.weOweGrid.gridAction.attachments') as string,
        visible: true,
        disable: (model: WeOwe) => {
          if (model.customerNumber) {
            return false;
          }
          return true;
        },
        action: (model: WeOwe) => {
          return {
            name: 'app.weowe.attachments',
            params: {
              weOweNumber: model.weOweNumber,
              customerkey: model.customerNumber,
            },
          };
        },
      },
      {
        type: 'button',
        icon: 'fas fa-clipboard-list',
        title: this.$t('weOweList.weOweGrid.gridAction.notes') as string,
        visible: true,
        action: (model: WeOwe) => {
          this.selectedWeOweNumber = model.weOweNumber;
          this.noteDialog.model = true;
          this.createEditor();
          this.notes = [];
          this.getNotes();
        },
      },
    ];
    this.noteActions = [
      {
        type: 'button',
        icon: 'fas fa-trash',
        title: this.$t('weOweList.weOweNoteGrid.gridAction.delete') as string,
        visible: true,
        action: (model: WeOweNote) => {
          this.selectedNoteId = model.id;
          this.deleteNoteDialog.model = true;
        },
      },
    ];
  }
  public async getWeOwes(): Promise<void> {
    try {
      this.loading = true;
      this.$emit('update:progress', this.loading);
      const response = await weOweService.getWeOwes(
        this.pagination,
        this.statusModel
      );
      this.weOwes = response.results;
      this.pagination.totalItems = response.total;
    } finally {
      this.loading = false;
      this.$emit('update:progress', this.loading);
    }
  }
  public async getNotes(): Promise<void> {
    try {
      this.noteLoading = true;
      const response = await weOweService.getNotes(
        this.selectedWeOweNumber
      );
      this.notes = response.results;
    } finally {
      this.noteLoading = false;
    }
  }
  public async addNote(): Promise<void> {
    this.noteText = this.richtext.getValue('markdown');
    if (!this.noteText) {
      this.showAlert(false, this.$t('weOweList.alertEnterNote'));
      return;
    }
    try {
      this.noteDialog.loading = true;
      await weOweService.addNote(this.selectedWeOweNumber, this.noteText);
      this.showAlert(true, this.$t('weOweList.alertNoteSaved'));
      this.noteText = '';
      this.richtext.setValue(this.markdown, this.dataType);
      this.getNotes();
    } finally {
      this.noteDialog.loading = false;
    }
  }
  public async deleteNote(): Promise<void> {
    try {
      this.deleteNoteDialog.loading = true;
      await weOweService.deleteNote(
        this.selectedWeOweNumber,
        this.selectedNoteId
      );
      this.showAlert(true, this.$t('weOweList.alertNoteDeleted'));
      this.getNotes();
    } finally {
      this.deleteNoteDialog.loading = false;
      this.deleteNoteDialog.model = false;
    }
  }
  public async downloadWeOwe(
    weOweNumber: string,
    action: VAction
  ): Promise<void> {
    try {
      action.loading = true;
      this.weOweDownloadLoader = true;
      const response = await weOweService.download(weOweNumber);
      const bytes = FileHelper.base64ToArrayBuffer(response.fileBase64);
      FileHelper.downloadBytes(bytes, '', response.fileDownloadName);
    } finally {
      this.weOweDownloadLoader = false;
      action.loading = false;
    }
  }
  public async getCustomerInfo(weOwe: WeOwe): Promise<void> {
    try {
      this.customerLoading = true;
      this.voiceCallDialog = true;
      const customer = await customerService.getCustomerInfoAsync(
        weOwe.customerNumber
      );
      this.customer = customer;
      this.customer.customerKey = weOwe.customerNumber;
      this.customer.other = '';
      this.customer.name =
        this.customer.lastName + ' ' + this.customer.firstName;

      this.setVoiceCallModel(weOwe);
    } finally {
      this.customerLoading = false;
    }
  }

  public setVoiceCallModel(weOwe: WeOwe): void {
    this.voiceCallModel.customerKey = this.customer.customerKey;
    this.voiceCallModel.customerName = this.customer.name;
    this.voiceCallModel.recordKey = weOwe.weOweNumber;
    this.voiceCallModel.vin = weOwe.vin;
  }

  public updatePaging(paging: PaginationModel): void {
    this.pagination = paging;
    const queryStringObj = Object.assign({}, paging) as any;
    if(queryStringObj){
      queryStringObj.status = this.statusModel;
    }
    Utils.validateAndUpdateRoute(queryStringObj);
    this.getWeOwes();
  }

  public updateNotePaging(paging: PaginationModel): void {
    this.notePagination = paging;
  }
  public searchWeOwe(): void {
    this.pagination.page = 1;
    const queryStringObj = Object.assign({}, this.pagination) as any;
    queryStringObj.status = this.statusModel;
    Utils.validateAndUpdateRoute(queryStringObj);
    this.getWeOwes();
  }
  public createEditor(): void {
    setTimeout(() => {
      if (!this.isTextEditorRender) {
        this.richtext = new Richtext(this.$refs.container, {
          mode: { type: String, default: 'classic' },
        });
        this.isTextEditorRender = true;
      }
    }, 0);
  }
}
